import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/vota.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>S&#228;mtliche schriften und briefe series I, volume 22</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 377-378<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 17 April 1703<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (90k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Carlo Maurizio Vota to Leibniz (17 April 1703)</title>
            <meta name="description" content="An English translation of a LETTER FROM CARLO MAURIZIO VOTA TO GOTTFRIED WILHELM LEIBNIZ, from 17 April 1703" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LETTER FROM CARLO MAURIZIO VOTA TO GOTTFRIED WILHELM LEIBNIZ</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A I 22, p377</b>]<br /><br />
                <span style={{float: 'right'}}>From Marienburg, 17 April 1703</span><br /><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I cannot adequately express the immense obligations I have to you for the honour of your excellent and marvellous letter, which I have read and reread several times with admiration for your profound knowledge and for your extraordinary mind in discovering this way of explaining the ancient characters of the Chinese that the Chinese themselves had forgotten. Your 0 and your 1 will be eternal monuments to your mind, and posterity will not have enough praise to celebrate them, as well as your broken lines which shed so many rays and lights on the world of letters, not only in China but also throughout Europe. Finally, you are an illustrious and new conqueror of things unknown. And if Columbus and Amerigo Vespucci have the glory of discovering new lands in the west, you have made a greater discovery by having given the east such uncommon knowledge. I do not intend to flatter you here, for you are above all vanity. And vanity is above my nature. But I simply want to give you here a glimpse of the esteem that everyone owes you, restraining myself to speculate more at my leisure on your writing, which I consider a treasure and which I passed on to the king, who took very great pleasure in seeing the fine discovery you have made. His Majesty, having made me read in his presence the whole of this wonderful project concerning the Education of the Prince,<a name="1" href="#note1"><sup>1</sup></a> wanted to know my view on it. I said so many good things about it to him and heaped so much praise on it that he is confirmed in the great esteem for your excellent mind and profound judgement. Certainly you have encompassed in a few words whole volumes, and you have omitted nothing of what the most perfect morals and the [<b>A I 22, p378</b>] choicest politics could wish for, and of what the sciences and the arts more worthy of a sovereign could imagine. I am not telling you a tenth of what I said to the king in your praise, in all mathematics, in history, chronology, geography and other areas in which your fine works make you a very noted figure in the present century and the one just finished. I am not flattering, and I tell you only what I think. I would be very glad to know the effect your discovery makes on China, and I have no doubt that this wise and great Emperor will do you proper justice there, as well as all the Jesuit fathers, among whom I would like you to give me some news about the state of Father Claude Philippe Grimaldi, namely whether he is alive, and if he has been believed Bishop of Perking, as has been written. He was my student and pupil. And he often wrote to me, even after his return to China, or rather to Goa. But my great distractions prevented me from maintaining communication. I beg you to give my very humble address to Her Majesty the Queen, and my respects to Mr Dombrezinski, and to Mr Jacquelot, Mr l'Enfant, and generally to all your learned and illustrious persons. I write in haste and am
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> That is, Leibniz's &quot;Lettre sur l'education d'un prince&quot; (1685-86), A IV 3, 542-557.
                <br /><br /><br />
                &#169; Lloyd Strickland 2020. Revised 2024
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
